/**
 * React hooks 封装：让页面针对 IndexedDB 的变化自动更新（Dexie liveQuery）。
 * 首次加载返回默认值（可传入），组件自行对 null/undefined 兜底。
 */
import { useLiveQuery } from "dexie-react-hooks";
import {
  getSettings,
  getTodayIntent,
  listMeals,
  listMeasurements,
  listTrainingTemplates,
  type AppSettings,
} from "./repo";
import { db } from "./db";
import type { TrainingTemplate, WorkoutSession } from "@jilian/shared";

export function useSettings(): AppSettings | null {
  return useLiveQuery(() => getSettings(), [], null);
}

export function useTodayIntent(userId: string, localDate: string) {
  return useLiveQuery(() => getTodayIntent(userId, localDate), [userId, localDate], null);
}

export function useMeals(userId: string) {
  return useLiveQuery(() => listMeals(userId), [userId]);
}

export function useMeasurements(userId: string) {
  return useLiveQuery(() => listMeasurements(userId), [userId]);
}

export function useTrainingTemplates(userId: string): TrainingTemplate[] | undefined {
  return useLiveQuery(() => listTrainingTemplates(userId), [userId]);
}

export function useRecentSessions(userId: string, limit = 20): WorkoutSession[] | undefined {
  return useLiveQuery(
    () => db.sessions.where("userId").equals(userId).reverse().sortBy("startedAt").then((list) => list.slice(0, limit)),
    [userId, limit],
  );
}

